export const CREATE_LAYER = 'app/sketch_tool/CREATE_LAYER';
export const UPDATE_LAYER = 'app/sketch_tool/UPDATE_LAYER';
export const DELETE_LAYER = 'app/sketch_tool/DELETE_LAYER';
export const DELETE_LAYERS = 'app/sketch_tool/DELETE_LAYERS';
export const REPLACE_LAYERS = 'app/sketch_tool/REPLACE_LAYERS';
export const SET_ACTIVE_LAYER = 'app/sketch_tool/SET_ACTIVE_LAYER';
export const CHANGE_SORT_ORDER = 'app/sketch_tool/CHANGE_SORT_ORDER';
export const FETCH_LAYER_OPTIONS = 'app/sketch_tool/FETCH_LAYER_OPTIONS';
export const FETCH_LAYER_OPTIONS_SUCCESS = 'app/sketch_tool/FETCH_LAYER_OPTIONS_SUCCESS';
export const FETCH_LAYER_OPTIONS_FAILURE = 'app/sketch_tool/FETCH_LAYER_OPTIONS_FAILURE';
export const FETCH_EXISTING_SKETCH_SUCCESS = 'app/sketch_tool/FETCH_EXISTING_SKETCH_SUCCESS';
export const SAVE_SKETCH_SUCCESS = 'app/sketch_tool/SAVE_SKETCH_SUCCESS';
export const FETCH_LAYER_DATA = 'app/sketch_tool/FETCH_LAYER_DATA';
export const FETCH_LAYER_DATA_SUCCESS = 'app/sketch_tool/FETCH_LAYER_DATA_SUCCESS';
export const FETCH_LAYER_DATA_FAILURE = 'app/sketch_tool/FETCH_LAYER_DATA_FAILURE';
export const UPDATE_SKETCH = 'app/sketch_tool/UPDATE_SKETCH';
export const UPDATE_ZOOM = 'app/sketch_tool/UPDATE_ZOOM';
export const UPDATE_MEASUREMENT_FONT_SIZE = 'app/sketch_tool/UPDATE_MEASUREMENT_FONT_SIZE';
export const UPDATE_CENTER = 'app/sketch_tool/UPDATE_CENTER';
export const SET_SELECTED_LAYER_ID = 'app/sketch_tool/SET_SELECTED_LAYER';
export const SET_SELECTED_POPUP_LAYER_ID = 'app/sketch_tool/SET_SELECTED_POPUP_LAYER_ID';

export const SET_MODE = 'app/sketch_tool/SET_MODE';
export const CREATE_TAPE_FEATURE = 'app/sketch_tool/CREATE_TAPE_FEATURE';
export const UPDATE_TAPE_FEATURE = 'app/sketch_tool/UPDATE_TAPE_FEATURE';
export const DELETE_TAPE_FEATURE = 'app/sketch_tool/DELETE_TAPE_FEATURE';
export const REPLACE_TAPE_FEATURES = 'app/sketch_tool/REPLACE_TAPE_FEATURES';
export const UNDO_TAPE_FEATURES = 'app/sketch_tool/UNDO_TAPE_FEATURES';
export const REDO_TAPE_FEATURES = 'app/sketch_tool/REDO_TAPE_FEATURES';
export const PUSH_TAPE_FEATURES_HISTORY = 'app/sketch_tool/PUSH_TAPE_FEATURES_HISTORY';
export const SET_SELECTED_TAPE_FEATURE_ID = 'app/sketch_tool/SET_SELECTED_TAPE_FEATURE_ID';
export const FETCH_EXISTING_TAPE_SKETCH_SUCCESS = 'app/sketch_tool/FETCH_EXISTING_TAPE_SKETCH_SUCCESS';
export const SAVE_TAPE_SKETCH_SUCCESS = 'app/sketch_tool/SAVE_TAPE_SKETCH_SUCCESS';
export const FETCH_TAPE_SKETCH_CONFIG_SUCCESS = 'app/sketch_tool/FETCH_TAPE_SKETCH_CONFIG_SUCCESS';
export const SHIFT_TAPE_SKETCH_ORIGIN = 'app/sketch_tool/SHIFT_TAPE_SKETCH_ORIGIN';
export const SET_TAPE_SKETCH_BEARING = 'app/sketch_tool/SET_TAPE_SKETCH_BEARING';
